"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assumeUser = void 0;
function assumeUser(client, opts) {
    return client.post('assume_user', {
        id_or_email: opts.idOrEmail
    });
}
exports.assumeUser = assumeUser;
